import styled from '@emotion/styled'

const MenuItemPizzaLeftView = styled.button<{
  isSelected?: boolean
  isDisabled?: boolean
}>`
  content: '';
  display: inline-block;
  position: relative;
  width: 2.4rem;
  height: 2.4rem;
  padding: 0;
  border-radius: 100%;
  border-width: 0.1rem;
  border-style: solid;
  transition: all 0.15s ease;
  background-color: ${(props) => props.theme.bgColors.primary};
  border-color: ${(props) => props.theme.colors.primary};
  opacity: ${(props) => (props.isSelected ? '1' : '0.5')};
  cursor: ${(props) => (props.isDisabled ? 'default' : 'pointer')};
`

const MenuItemPizzaLeftInner = styled.span`
  content: '';
  position: absolute;
  top: 0.1rem;
  left: 0.1rem;
  height: 2rem;
  width: 1.1rem;
  border-radius: 2.4rem 0 0 2.4rem;
  background-color: ${(props) => props.theme.colors.primary};
`

interface MenuItemPizzaLeftProps {
  onClick: () => void
  isSelected?: boolean
  isDisabled?: boolean
}

const MenuItemPizzaLeft = ({
  onClick,
  isSelected,
  isDisabled,
}: MenuItemPizzaLeftProps) => {
  return (
    <MenuItemPizzaLeftView
      onClick={onClick}
      isSelected={isSelected}
      isDisabled={isDisabled}
    >
      <MenuItemPizzaLeftInner />
    </MenuItemPizzaLeftView>
  )
}

export default MenuItemPizzaLeft
